// extracted by mini-css-extract-plugin
export default {"list":"styles_list__A5O5X","watsApp":"styles_watsApp__99tul","topContacts":"styles_topContacts__01HWr","phone":"styles_phone__sVDA9"};